// Lightweight Vuex module for caching shared reference data used by detail pages
import DeptDataService from "../services/DeptDataService";
import BranchDataService from "../services/BranchDataService";
import MemberDataService from "../services/MemberDataService";
import InsDataService from "../services/InsDataService";
import StageDataService from "../services/StageDataService";

const state = {
  refLoaded: false,
  refLoading: false,
  departments: [],
  branches: [],
  members: [],
  insurers: [],
  stages: [],
};

const getters = {
  deptById: (s) => (id) => s.departments.find((d) => d.id === id),
  branchById: (s) => (id) => s.branches.find((b) => b.id === id),
  memberById: (s) => (id) => s.members.find((m) => m.id === id),
  insurerById: (s) => (id) => s.insurers.find((i) => i.id === id),
  stageByCode: (s) => (code) => s.stages.find((st) => st.stageCode === code),
};

const actions = {
  async ensureRefs({ state, commit }) {
    if (state.refLoaded || state.refLoading) return;
    commit("setLoading", true);
    try {
      const [depts, branches, members, insurers, stages] = await Promise.all([
        DeptDataService.getAll(),
        BranchDataService.getAll(),
        MemberDataService.getAll(),
        InsDataService.getAll(),
        StageDataService.getAll(),
      ]);

      commit("setDepartments", depts.data || []);
      commit("setBranches", branches.data || []);
      commit("setMembers", members.data || []);
      commit("setInsurers", insurers.data || []);
      commit("setStages", stages.data || []);
      commit("setLoaded", true);
    } catch (e) {
      // Keep module safe on failures — callers should handle missing refs gracefully
      console.error("referenceData.ensureRefs failed", e);
    } finally {
      commit("setLoading", false);
    }
  },
};

const mutations = {
  setLoading(s, v) {
    s.refLoading = v;
  },
  setLoaded(s, v) {
    s.refLoaded = v;
  },
  setDepartments(s, v) {
    s.departments = v;
  },
  setBranches(s, v) {
    s.branches = v;
  },
  setMembers(s, v) {
    s.members = v;
  },
  setInsurers(s, v) {
    s.insurers = v;
  },
  setStages(s, v) {
    s.stages = v;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
